require('./cmView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const NotFoundView = require('routes/notFoundView/notFoundView');

let showGDI = require('core/environmentConfig').GDI;

class CmView extends React.Component {
    render() {
        return showGDI ? (
            <section className="cm-view">{this.props.children}</section>
        ) : (
            <NotFoundView />
        );
    }
}

CmView.propTypes = {
    children: PropTypes.object,
};

module.exports = CmView;
